/*
 * You can use different validation classes to provide valuable feedback to users. 
 * Add either .was-validated or .needs-validation to the <form> element, depending on whether you want 
 * to provide validation feedback before or after submitting the form. The input fields will have a green (valid) 
 * or red (invalid) border to indicate what's missing in the form. 
 * 
 * You can also add a .valid-feedback or .invalid-feedback message to tell the user explicitly what's missing, 
 * or needs to be done before submitting the form.
 * https://www.w3schools.com/bootstrap4/bootstrap_forms.asp
 */
(($) => {
    function overload(settings: JQueryValidation.ValidationOptions, setting: "highlight" | "unhighlight", func: (elm: HTMLElement) => void) {
        const def = settings[setting]!;

        settings[setting] = function (elm, ...rest) {
            def.apply(this, [elm, ...rest]);
            setTimeout(() => func(elm));
        };
    }

    function removeParentsClass(elm: HTMLElement, className: string) {
        $(elm).parents('.' + className).removeClass(className)
    }

    function toggleInputGroupClass(elm: HTMLElement, valid: boolean) {
        removeParentsClass(elm, valid ? 'input-group-invalid' : 'input-group-valid')
        $(elm).parents('.input-group').addClass(valid ? 'input-group-valid' : 'input-group-invalid');
    }

    // https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/url2.js
    // Same as url, but TLD is optional
    $.validator.addMethod("url2", function (this:any, value, element) {
        return this.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?)|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff])|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62}\.)))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
    }, $.validator.messages.url);

    $.validator.unobtrusive.adapters.addBool("url2");

    $ && $.fn.validate! && $(() => {
        $('form').each(function () {
            const validator = $(this).data('validator') as JQueryValidation.Validator;

            if (validator) {
                const { settings } = validator;
                settings.ignore = ""; // remove ':hidden' setting to validate hidden fields
                settings.errorElement = "div" // must use div or label styles will override .invalid-feedback
                settings.errorClass = "is-invalid";
                settings.validClass = "is-valid";
                overload(settings, "highlight", elm => toggleInputGroupClass(elm, false));
                overload(settings, "unhighlight", elm => toggleInputGroupClass(elm, true));
            }
        });

    });
})($);
